import React from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";

import Header from "./Header";
import Footer from "./Footer";

const Main =(props)=>{

    return(
        <HelmetProvider>
            <Helmet
                titleTemplate="태성 %s 페이지 입니다."
                defaultTitle="태성엔지니어링입니다."
                defer={false}
            >
                {<title>{props.title}</title>}
                <meta name="description" content={props.desciption}/>

            </Helmet>

            <Header/>

            <main id="main" role="main">
                {props.children}
            </main>

            <Footer/>



        </HelmetProvider>     

    )
}

export default Main;